import { useState } from "react";
import { Link, useParams } from "react-router-dom";
import Navbar from "@/components/feature/Navbar";
import Footer from "@/components/feature/Footer";
import usePageMeta from "@/hooks/usePageMeta";
import { getFilmById, typeLabels } from "@/lib/films";
import DetailHero from "./components/DetailHero";
import DetailContent from "./components/DetailContent";
import DetailSidebar from "./components/DetailSidebar";
import ShareDialog from "./components/ShareDialog";

export default function Detail() {
  const { id } = useParams();
  const film = getFilmById(id);
  const [shareOpen, setShareOpen] = useState(false);

  usePageMeta({
    title: film
      ? `${film.title} - 剧情介绍与影评 - 人兽影视网`
      : "未找到该影视作品 - 人兽影视网",
    description: film
      ? `${film.title}（${film.year}，${film.region}）由${film.director}执导，${film.cast
          .slice(0, 3)
          .join("、")}主演。${film.intro}人兽影视网提供完整剧情介绍、演员资料与影评解读。`
      : "该影视作品可能已下架或链接有误，请返回首页重新浏览人兽影视网的影视条目。",
    keywords: film
      ? `${film.title},${film.title}剧情介绍,${film.title}影评,${film.genres.join(",")},${film.cast[0]}`
      : "影视作品,剧情介绍,影评,人兽影视网",
  });

  if (!film) {
    return (
      <div className="min-h-screen bg-background-50">
        <Navbar />
        <main className="container-portal flex min-h-[60vh] flex-col items-center justify-center py-20 text-center">
          <span className="flex h-14 w-14 items-center justify-center rounded-full bg-background-100 text-foreground-400">
            <i className="ri-film-line text-2xl" />
          </span>
          <h1 className="mt-5 text-2xl font-bold text-foreground-950">未找到该影视作品</h1>
          <p className="mt-3 max-w-md text-sm leading-7 text-foreground-600">
            页面链接可能已失效，或该条目暂未收录。你可以返回首页，或按分类继续浏览。
          </p>
          <div className="mt-6 flex flex-wrap justify-center gap-3">
            <Link
              to="/"
              className="inline-flex items-center gap-1.5 rounded-md bg-primary-500 px-4 py-2.5 text-sm font-medium text-background-50 transition-colors hover:bg-primary-600 cursor-pointer whitespace-nowrap"
            >
              返回首页
            </Link>
            <Link
              to="/category/movie"
              className="inline-flex items-center gap-1.5 rounded-md border border-background-300 px-4 py-2.5 text-sm text-foreground-700 transition-colors hover:bg-background-100 cursor-pointer whitespace-nowrap"
            >
              浏览电影
            </Link>
          </div>
        </main>
        <Footer />
      </div>
    );
  }

  return (
    <div className="min-h-screen bg-background-50">
      <Navbar />
      <main>
        <DetailHero film={film} onShare={() => setShareOpen(true)} />

        <div className="container-portal mt-6 grid grid-cols-1 gap-6 pb-4 lg:grid-cols-[minmax(0,1fr)_320px] lg:gap-7">
          <div className="min-w-0">
            <div className="flex flex-wrap items-center gap-2 text-[11px] text-foreground-500">
              <span className="rounded bg-secondary-100 px-2 py-0.5 text-secondary-900">
                {typeLabels[film.type]}
              </span>
              <span>{film.year}</span>
              <span className="h-2.5 w-px bg-background-300" />
              <span>{film.region}</span>
              <span className="h-2.5 w-px bg-background-300" />
              <span>{film.length}</span>
              <span className="h-2.5 w-px bg-background-300" />
              <span>{film.reviews.length} 篇影评</span>
            </div>
            <div className="mt-4">
              <DetailContent film={film} />
            </div>
          </div>
          <DetailSidebar film={film} />
        </div>
      </main>
      <Footer />

      <ShareDialog open={shareOpen} onClose={() => setShareOpen(false)} title={film.title} />
    </div>
  );
}